import { Text } from '../Text';

export const Overline = Text.withProps({ variant: 'overline' }, { name: 'Overline' });
